import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
import Swal from 'sweetalert2'
import TablePagination from '@mui/material/TablePagination';
import ReactLoading from 'react-loading';
import exportValue from "../../apiconfig";
import Sub_header from '../Sub_header';
import Left_panel from "../Left_panel";
import { sub } from "date-fns";
import { useNavigate } from "react-router-dom";
import Moment from 'react-moment';
import moment from 'moment'
import * as XLSX from 'xlsx'
import html2pdf from 'html2pdf.js';
import Shipment_detail from "../Shipments/Shipment_detail";

const Weight_discrepencies_dispute = () => {
  let navigate = useNavigate()
  const search1 = window.location.search;
  const params = new URLSearchParams(search1);
  const [state, setState] = useState({ isLoading: true, user_list: [] });
  const [statesummary, setStatesummary] = useState({  user_list_summary: [] });
  const [showCanvas, setShowCanvas] = useState(false);
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [otherStates, setOtherState] = useState({ dstatus: 4, activePage: 1, rowsPerPage: 10 , page: 0, total_count: 0, onload: true });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [viewModal, setviewModal] = React.useState({ show: false, sub: {} })
  console.log("viewModal ---" , viewModal)
  const [disputeText, setDisputeText] = React.useState('');
  const [images, setImages] = React.useState([]);
  const [videos, setVideos] = useState([]);
  const [disablebutton, setdisablebutton] = React.useState(false)
  const [uploading, setUploading] = useState(false);
  const [imageModal, setImageModal] = useState({
    show: false,
    shipment: {},
    image: "",
  });

  const [partialAcceptModal, setPartialAcceptModal] = useState({
    show: false,
    shipment: null,
    weight: "",
  });
  
  const [partialAcceptLoading, setPartialAcceptLoading] =
    useState(false);
  const [bulkModal, setBulkModal] = useState(false);
const [bulkFile, setBulkFile] = useState(null);
  
  const [proofImage, setProofImage] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const getDefaultDates = () => {
    const today = new Date();
  
    const oneMonthBefore = new Date();
    oneMonthBefore.setMonth(oneMonthBefore.getMonth() - 1);
  
    return {
      from_date: oneMonthBefore.toISOString().split("T")[0],
      to_date: today.toISOString().split("T")[0],
    };
  };
  
  const [filterState, setFilterState] = useState(getDefaultDates());
  const[findstate , setfindstate] = React.useState({find:""})
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 5000
  })

  useEffect(() => {
    getUsersList(otherStates.page, true , otherStates.rowsPerPage);
  
  }, [otherStates.dstatus])

  useEffect(() => {
    getUsersList(otherStates.page, true , otherStates.rowsPerPage);
   
  }, [])

  const getUsersList = (index = 0, onLoad) => {

    setIsLoading(true)
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/weight_discrepancies_dispute_list`;
    let sendData = { discrepencies_status: otherStates.dstatus, limit: otherStates.rowsPerPage, indexValue: index, carrier_type: "B2C" };
if(findstate.find!=""){
  sendData.find = findstate.find
}
if (
  filterState.from_date &&
  filterState.to_date
) {
  sendData.from_date = filterState.from_date;
  sendData.to_date = filterState.to_date;
}

    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
      setIsLoading(false)

      setOtherState(prev => ({
        ...prev,
        total_count: (index === 0 && onLoad) ? res.data.count : prev.total_count,
        page: index
      }));
      setState({ ...state, user_list: res.data.output, isLoading: false })



    }).catch((e) => {
      setIsLoading(false)

    });
  }

  const getdiscrepancyList = async () => {
    try {
      setIsLoader(true);
  
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/weight_discrepancies_dispute_list_summary`;
  
      let sendData = {
        discrepencies_status: otherStates.dstatus,
        carrier_type: "B2C",
      };
  
      if (findstate.find !== "") {
        sendData.find = findstate.find;
      }
  
      if (
        filterState.from_date &&
        filterState.to_date
      ) {
        sendData.from_date = filterState.from_date;
        sendData.to_date = filterState.to_date;
      }
      const res = await axios.post(full_api, sendData, {
        headers: exportValue.headers,
      });
  
      // ⬇️ directly pass data
      await downloadExcelInvoice(res.data.output);
  
    } catch (error) {
      console.error(error);
    } finally {
      // ✅ loader stops only after file is generated
      setIsLoader(false);
    }
  };

  const handlePageChange = (event, newPage) => {
    setOtherState({ ...otherStates, page: newPage })
    //console.log("newPage ", newPage);
    getUsersList(newPage, true, otherStates.rowsPerPage);
  }
  const handleChangeRowsPerPage = (event) => {
    //console.log("event ", event.target.value);        
    setOtherState({ ...otherStates, rowsPerPage: event.target.value })
    getUsersList(otherStates.page, true, event.target.value)
  }

  const statusChange = (status) => {
    setOtherState({ ...otherStates, dstatus: status })
  }


  const changedisputestatus = (item, status) => {
    console.log("item == " , item)
    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/weight_discrepancies_dispute_status_update`;
    let sendData = { shipment_id: item.shipment_id, order_number: item.order_number, customer_id: item.customer_id, status: status };


    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
      if (res.data.status == true) {
        Swal.fire({
          icon:  "success",
          text:  res.data.message ||
          "Something went wrong",
        });
        getUsersList(otherStates.page, true , otherStates.rowsPerPage)
      }
      else {
      
        Swal.fire({
          icon:  "error",
          text:  res.data.message ||
          "Something went wrong",
        });
      }

    }).catch((e) => {
      Toast.fire({
        background: "#e63900",
        type: 'error',
        title: "Something Went Wrong",
        color: "white"
      });

    });
  }
  const handleImageUpload = (e) => {
    const uploadedImages = Array.from(e.target.files);

    // Check the number of selected images
    if (uploadedImages.length + images.length > 3) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "You can only upload up to 3 images.",
      });
      return;
    }

    // Check the total size of selected images
    const totalSize = uploadedImages.reduce((acc, img) => acc + img.size, 0);
    if (
      (uploadedImages.length === 1 && totalSize > 3 * 1024 * 1024) ||
      (uploadedImages.length === 2 && totalSize > 6 * 1024 * 1024) ||
      (uploadedImages.length === 3 && totalSize > 10 * 1024 * 1024)
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "Total image size exceeds the allowed limit.",
      });
      return;
    }

    setImages(prevImages => [...prevImages, ...uploadedImages]);
  };
  const handleVideoUpload = (e) => {
    const uploadedVideos = Array.from(e.target.files);

    // Check the number of selected videos
    if (uploadedVideos.length + videos.length > 3) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "You can only upload up to 3 videos.",
      });
      return;
    }

    // Check the total size of selected videos
    const totalSize = uploadedVideos.reduce((acc, vid) => acc + vid.size, 0);
    if (
      (uploadedVideos.length === 1 && totalSize > 30 * 1024 * 1024) ||
      (uploadedVideos.length === 2 && totalSize > 60 * 1024 * 1024) ||
      (uploadedVideos.length === 3 && totalSize > 100 * 1024 * 1024)
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "Total video size exceeds the allowed limit.",
      });
      return;
    }

    setVideos(prevVideos => [...prevVideos, ...uploadedVideos]);
  };


  const removeImage = (index) => {
    setImages(prevImages => prevImages.filter((_, i) => i !== index));
  };

  const removeVideo = (index) => {
    setVideos(prevVideos => prevVideos.filter((_, i) => i !== index));
  };

  const handleupdateSubmit = () => {
    setdisablebutton(true)
    submitupdateDispute(disputeText, images, videos);
  };
  const submitupdateDispute = async (disputeText, images, videos) => {
    if (disputeText === "") {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "Please enter dispute issue",
      });
      setdisablebutton(false)
      return;
    }

    const formData = new FormData();
    formData.append('disputeText', disputeText);
    formData.append('customerid', viewModal.sub.customer_id);
    formData.append('shipmentid', viewModal.sub.shipment_id);

    images.forEach((image, index) => {
      formData.append(`image${index}`, image);
    });

    videos.forEach((video, index) => {
      formData.append(`video${index}`, video);
    });

    try {
      const response = await axios.post(exportValue.host + "/" + exportValue.version + "/" + exportValue.api + '/update_admin_submit_dispute', formData, { headers: exportValue.headers });
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Success...',
          text: "Dispute updated successfully!",
        });
        handlecloseviewmodals();
        setdisablebutton(false)
        getUsersList(otherStates.page, true , otherStates.rowsPerPage)
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: "Failed to update dispute. Please try again.",
        });
        setdisablebutton(false)
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: "An error occurred. Please try again.",
      });
      setdisablebutton(false)
    }
  };
  const handlecloseviewmodals = () => {
    setviewModal({ show: false, sub: {} })
    setDisputeText('')
    setImages([])
    setVideos([])
  }

  const downloadExcelInvoice = async (list) => {
    if (!list || list.length === 0) return;
  
    const excelData = list.map((sub) => {
      console.log("sub.dispute_raised_on = =" , sub.dispute_raised_on)
      const updatedOn = sub.discrepencies_date
        ? `${moment.unix(sub.discrepencies_date).format("MMM DD YYYY")} - ${moment
            .unix(sub.discrepencies_date)
            .format("hh:mm:ss a")}`
        : "-";
  
      const disputeRaisedOn = sub.dispute_raised_on
        ? moment.unix(sub.dispute_raised_on).format("DD MMM YYYY")
        : "-";
  
      let statusText = "";
      switch (sub.discrepencies_dispute_status) {
        case 0:
          statusText = "Action Required";
          break;
        case 1:
          statusText = "Dispute Raised";
          break;
        case 2:
          statusText = "Accepted";
          break;
        case 3:
          statusText = "Closed";
          break;
        case 5:
          statusText = "Partially Accepted";
          break;
        default:
          statusText = "-";
      }
  
      return {
        "Updated On": updatedOn,
        "AWB No.": sub.carrier_tracking_number || "",
        "Carrier": sub.carrier_name || "",
        "Booking Weight (KG)": sub.total_weight ?? "-",
        "Initial Amount": Number(sub.total_amount || 0).toFixed(2),
        "Courier Weight (KG)":
          sub.discrepencies_weight ?? sub.total_weight ?? "-",
        "Updated Amount": Number(
          sub.discrepencies_amount ?? sub.total_amount ?? 0
        ).toFixed(2),
        "Final Weight (KG)":
          sub.final_weight ??
          "-",
        "Final Amount":
          sub.final_amount != null
            ? Number(sub.final_amount).toFixed(2)
           
            : "-",
        "Image Proof": sub.image_proof ?  sub.image_proof: "Not Available",
        Issue:
          sub.discrepencies_dispute_status === 0
            ? ""
            : sub.discrepencies_dispute_issue?.join(", ") || "Raised",
        Status: statusText,
        "Dispute Raised On": disputeRaisedOn,
      };
    });
  
    const worksheet = XLSX.utils.json_to_sheet(excelData);
  
    // Optional: Auto-size columns
    worksheet["!cols"] = [
      { wch: 28 }, // Updated On
      { wch: 22 }, // AWB
      { wch: 25 }, // Carrier
      { wch: 18 }, // Booking Weight
      { wch: 15 }, // Initial Amount
      { wch: 18 }, // Courier Weight
      { wch: 15 }, // Updated Amount
      { wch: 15 }, // Final Weight
      { wch: 15 }, // Final Amount
      { wch: 18 }, // Image Proof
      { wch: 40 }, // Issue
      { wch: 20 }, // Status
      { wch: 20 }, // Dispute Raised On
    ];
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Discrepencies");
  
    XLSX.writeFile(workbook, "Discrepencies.xlsx");
  };

  const openShipment = (id) => {
    console.log("id == " , id)
    setSelectedShipmentId(id);
    setShowCanvas(true);
  };

  const openImageProofModal = (shipment) => {
    setProofImage(null);
  
    setImageModal({
      show: true,
      shipment,
      image:
        shipment.image_proof ||
        shipment.sorter_image ||
        "",
    });
  };
  const handleProofUpload = (e) => {
    if (e.target.files?.length) {
      setProofImage(e.target.files[0]);
    }
  };
  const uploadProofImage = async () => {
    try {
      if (!proofImage) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please select image",
        });
  
        return;
      }
  
      setImageUploading(true);
  
      const formData = new FormData();
  
      formData.append(
        "shipment_id",
        imageModal.shipment.shipment_id
      );
  
      formData.append(
        "customer_id",
        imageModal.shipment.customer_id
      );
  
      formData.append(
        "image",
        proofImage
      );
  
      const response = await axios.post(
        exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          "/upload_discrepancy_proof_image",
        formData,
        {
          headers: exportValue.headers,
        }
      );
  
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Image uploaded successfully",
        });
  
        setImageModal({
          show: false,
          shipment: {},
          image: "",
        });
  
        setProofImage(null);
  
        getUsersList(
          otherStates.page,
          true,
          otherStates.rowsPerPage
        );
      }
    } catch (error) {
      console.log(error);
  
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Upload failed",
      });
    } finally {
      setImageUploading(false);
    }
  };

  const downloadSampleCSV = () => {
    const csv =
  `AWB,Dispute Resolution,Final Weight
  123456789,Accepted,2
  987654321,Rejected,
  987654321,Partially Accepted,2`;
  
  
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement("a");
  
    link.href = url;
    link.download = "weight_dispute_sample.csv";
    link.click();
  };
  
  const uploadBulkFile = async () => {
    if (!bulkFile) {
      return Swal.fire({
        icon: "error",
        text: "Please select CSV file",
      });
    }
    try{
    setUploading(true)
  
    const formData = new FormData();
    formData.append("file", bulkFile);
  
    const response = await axios.post(
      exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api + "/bulk_weight_dispute_resolution",
      formData,
      {
        headers: {
          ...exportValue.headers,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const results = response.data?.results || [];

const successCount = results.filter((r) => r.status).length;
const failed = results.filter((r) => !r.status);

await Swal.fire({
  icon: response.data.status ? "success" : "error",
  title: response.data.message,
  html: `
    <div style="text-align:left">
      <p><b>Total Records:</b> ${results.length}</p>
      <p><b>Successful:</b> ${successCount}</p>
      <p><b>Failed:</b> ${failed.length}</p>

      ${
        failed.length
          ? `
            <hr/>
            <div style="max-height:250px;overflow-y:auto;">
              ${failed
                .map(
                  (item) => `
                    <div style="margin-bottom:8px;">
                      <b>AWB:</b> ${item.awb}<br/>
                      <span style="color:red">${item.reason}</span>
                    </div>
                  `
                )
                .join("")}
            </div>
          `
          : ""
      }
    </div>
  `,
  width: 700,
});
  
   
if (response.data.status) {
  setBulkModal(false);
  setBulkFile(null);

  if (successCount > 0) {
    getUsersList(
      otherStates.page,
      true,
      otherStates.rowsPerPage
    );
  }
}
  }
  catch (err) {
    Swal.fire({
      icon: "error",
      text: "Something went wrong",
    });
  } finally {
    setUploading(false);
  }
  };

  const handlePartialAccept = async () => {
    try {
      if (!partialAcceptModal.weight) {
        
        Swal.fire({
          icon:  "error",
          text: "Please enter weight",
        });
        return;
      }
  
      if (Number(partialAcceptModal.weight) <= 0) {
        
        Swal.fire({
          icon:  "error",
          text: "Weight must be greater than 0",
        });
        return;
      }
  
      setPartialAcceptLoading(true);
  
      const response = await axios.post(
        exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +"/partial_accept_dispute",
        {
          shipment_id:
            partialAcceptModal.shipment.shipment_id,
          weight: partialAcceptModal.weight,
        },
        {
          headers: exportValue.headers,
        }
      );
  
      if (response.data.status) {
       
        Swal.fire({
          icon:  "success",
          text: "Dispute partially accepted",
        });
  
        setPartialAcceptModal({
          show: false,
          shipment: null,
          weight: "",
        });
  
       
        getUsersList(
          otherStates.page,
          true,
          otherStates.rowsPerPage
        );
      } else {
       
        Swal.fire({
          icon:  "error",
          text:  response.data.message ||
          "Something went wrong",
        });
      }
    } catch (err) {
      console.log(err);
  
      Swal.fire({
        icon:  "error",
        text:  
        "Something went wrong",
      });
    } finally {
      setPartialAcceptLoading(false);
    }
  };
  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <section class="home-section">
   <Sub_header />
        <div class="row py-4">
          <div class="col-12 col-md-12">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <ol class="breadcrumb breadcrumb-dark breadcrumb-transparent">
                <li class="breadcrumb-item">
                  <a href="#">
                    <svg class="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                  </a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Discrepancies Dispute B2C</li>
              </ol>
            </nav>
            <h2 class="h4">Discrepancies Dispute B2C</h2>
          </div>
          <div className="col-md-12">
  <div className="row">

    <div className="col-md-2">
      <input
        type="date"
        className="form-control"
        value={filterState.from_date}
        onChange={(e) =>
          setFilterState((prev) => ({
            ...prev,
            from_date: e.target.value,
          }))
        }
      />
    </div>

    <div className="col-md-2">
      <input
        type="date"
        className="form-control"
        value={filterState.to_date}
        onChange={(e) =>
          setFilterState((prev) => ({
            ...prev,
            to_date: e.target.value,
          }))
        }
      />
    </div>

    <div className="col-md-3">
      <div className="input-group">
        <span
          className="input-group-text"
          style={{ cursor: "pointer" }}
          onClick={() =>
            getUsersList(
              0,
              true,
              otherStates.rowsPerPage
            )
          }
        >
          <svg
            className="icon icon-xs"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clipRule="evenodd"
            />
          </svg>
        </span>

        <input
          type="text"
          className="form-control"
          placeholder="Search AWB"
          onChange={(e) =>
            setfindstate({
              find: e.target.value,
            })
          }
        />
      </div>
    </div>

    <div className="col-md-1">
      <button
        className="btn btn-primary w-100"
        onClick={() =>
          getUsersList(
            0,
            true,
            otherStates.rowsPerPage
          )
        }
      >
        Search
      </button>
    </div>
    <div class="col-md-2">
                {state.user_list.length>0?
            <div class="">
                      <button
  className="btn btn-primary g-1"
  onClick={getdiscrepancyList}
  disabled={isLoader}
>
  {isLoader ? "Downloading..." : "Download Summary"}
</button>
                    </div>
:""}
        </div>
        <div className="col-md-2">
        <button
  className="btn btn-primary"
  onClick={() => setBulkModal(true)}
>
  Bulk Actions
</button>
        </div>
       

  </div>
</div>
       
        </div>
        <Modal
  show={bulkModal}
  onHide={() => setBulkModal(false)}
>
  <Modal.Header closeButton>
    <Modal.Title>
      Bulk Dispute Resolution
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>

    <button
      className="btn btn-success mb-3"
      onClick={downloadSampleCSV}
    >
      Download Sample CSV
    </button>

    <input
      type="file"
      accept=".csv"
      className="form-control"
      onChange={(e) =>
        setBulkFile(e.target.files[0])
      }
    />

  </Modal.Body>

  <Modal.Footer>
    <button
      className="btn btn-secondary"
      onClick={() => setBulkModal(false)}
    >
      Close
    </button>

    <button
      className="btn btn-primary"
      onClick={uploadBulkFile}
      disabled={uploading}
    >
      {uploading ? "Uploading..." : "Upload"}
    </button>
  </Modal.Footer>
</Modal>
   <section>
  
          <ul class="nav nav-tabs justify-content-end">
            <li class="nav-item">
              <a class={"nav-link" + (otherStates.dstatus == 4 ? " active" : "")} style={{ cursor: 'pointer' }} onClick={() => statusChange(4)}>All</a>
            </li>
            <li class="nav-item">
              <a class={"nav-link" + (otherStates.dstatus == 0 ? " active" : "")} style={{ cursor: 'pointer' }} onClick={() => statusChange(0)}>Action Required</a>
            </li>
            <li class="nav-item">
              <a class={"nav-link" + (otherStates.dstatus == 1 ? " active" : "")} style={{ cursor: 'pointer' }} onClick={() => statusChange(1)}>Dispute Raised</a>
            </li>
            <li class="nav-item">
              <a class={"nav-link" + (otherStates.dstatus == 2 ? " active" : "")} style={{ cursor: 'pointer' }} onClick={() => statusChange(2)}>Accepted</a>
            </li>
            <li class="nav-item">
              <a class={"nav-link" + (otherStates.dstatus == 3 ? " active" : "")} style={{ cursor: 'pointer' }} onClick={() => statusChange(3)}>Closed</a>
            </li>
            <li class="nav-item">
              <a class={"nav-link" + (otherStates.dstatus == 5 ? " active" : "")} style={{ cursor: 'pointer' }} onClick={() => statusChange(5)}>Partially Accepted</a>
            </li>
     </ul>
        </section>
        {(isLoading) ?
          <div style={{ backgroundColor: "#808080", zIndex: 2, height: "100%", width: "100%", position: "absolute", opacity: "0.5" }}>
            <div style={{ left: "47%", top: "45%", position: "absolute" }}>
              <ReactLoading type={"spin"} color={"#000000"} height={300} width={89} />
            </div>
          </div> :
          <div class="card card-body border-0 shadow table-wrapper table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
    <th class="border-gray-200">Updated On</th>
                  <th class="border-gray-200">AWB No.</th>
                  <th class="border-gray-200">Booking Weight</th>
                  <th class="border-gray-200">Initial Amount</th>
                  <th class="border-gray-200">Courier Weight</th>
                  <th class="border-gray-200">Updated Amount</th>
                  <th class="border-gray-200">Final Weight</th>
                  <th class="border-gray-200">Final Amount</th>

                  <th class="border-gray-200">Image Proof</th>
                  <th class="border-gray-200">Issue</th>
                  <th class="border-gray-200">Status</th>
                  <th class="border-gray-200">Dispute Raised On</th>
                  <th class="border-gray-200">Action</th>
                </tr>
              </thead>
              <tbody>
                {state.user_list.map((sub, index) =>
                  <tr>
                    <td>
                      <p><small><Moment format="MMM DD YYYY">
                        {new Date(sub.discrepencies_date * 1000)}
                      </Moment> - <Moment format="hh:mm:ss a">
                          {new Date(sub.discrepencies_date * 1000)}
                        </Moment></small></p>
                    </td>
                    <td>
                      <strong><a onClick={() => openShipment(sub.shipment_id)} style={{ textDecoration: "none" }}>{sub.carrier_tracking_number}</a></strong><br />
                      <p>{sub.carrier_name}</p>
                    </td>
    <td class="location_box_239">
                      <p>{sub.total_weight}KG</p>

                    </td>
                    <td>{sub.total_amount.toFixed(2)}</td>

                    <td>
{sub.discrepencies_weight
  ? sub.discrepencies_weight
  : sub.total_weight}
  KG
</td>

                    <td>{sub.discrepencies_amount ? sub.discrepencies_amount.toFixed(2) : sub.total_amount.toFixed(2)}</td>
                    <td>{sub.final_weight?(`${sub.final_weight} KG`):'-'}</td>
                    <td>
  {sub.final_amount !== undefined &&
  sub.final_amount !== null &&
  sub.final_amount !== ""
    ? Number(sub.final_amount).toFixed(2)
    : "-"}
</td>
                    <td>
  <button
    className="btn btn-primary btn-sm"
    onClick={() => openImageProofModal(sub)}
  >
    View
  </button>
</td>
                    <td>{sub.discrepencies_dispute_status == 0 ?
                      ""
                      : <a onClick={() => setviewModal({ show: true, sub: sub })} style={{ cursor: "pointer" }} class="btn btn-primary" >
                        View
                      </a>}</td>
               
                     <td>
                      {sub.discrepencies_dispute_status == 0 ? <span class="badge rounded-pill bg-warning fw-400">Action Required</span> : sub.discrepencies_dispute_status == 1 ? <span class="badge rounded-pill bg-primary fw-400">Dispute Raised</span> : sub.discrepencies_dispute_status == 2 ? <span class="badge rounded-pill bg-success fw-400">Accepted</span> : sub.discrepencies_dispute_status == 3 ? <span class="badge rounded-pill bg-danger fw-400">Closed</span>:sub.discrepencies_dispute_status == 5 ? <span class="badge rounded-pill bg-danger fw-400">Partially Accepted</span> : ""}
                    </td>
                    <td>
{sub.dispute_raised_on ?
 moment.unix(sub.dispute_raised_on).format("DD MMM YYYY")
 : "-"
}
</td>
                    <td>
                      {sub.discrepencies_dispute_status == 1 ?
                        <>  <a className="btn btn-primary" onClick={(e) => changedisputestatus(sub, 2)}>Accept</a>
                          <a className="btn btn-primary ms-1" onClick={(e) => changedisputestatus(sub, 3)}>Close</a>
                          <a className="btn btn-primary ms-1" onClick={() =>
    setPartialAcceptModal({
      show: true,
      shipment: sub,
      weight: "",
    })
  }>Partial Accept</a>
                          </>


                        // : sub.discrepencies_dispute_status == 2 ?
                        //   <a className="btn btn-primary ms-1" onClick={(e) => changedisputestatus(sub, 3)}>Close</a> 
                          : ""
                      }
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
            <Modal
  show={partialAcceptModal.show}
  onHide={() =>
    setPartialAcceptModal({
      show: false,
      shipment: null,
      weight: "",
    })
  }
>
  <Modal.Header closeButton>
    <Modal.Title>Partial Accept</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <label>Updated Weight (KG)</label>

    <input
      type="number"
      step="0.001"
      className="form-control"
      value={partialAcceptModal.weight}
      onChange={(e) =>
        setPartialAcceptModal({
          ...partialAcceptModal,
          weight: e.target.value,
        })
      }
    />
  </Modal.Body>

  <Modal.Footer>
    <button
      className="btn btn-primary"
      onClick={handlePartialAccept}
    >
      OK
    </button>
  </Modal.Footer>
</Modal>
            <TablePagination
              component="div"
              rowsPerPageOptions={[10, 20 , 30 , 40 , 50 , 60 , 70 , 80 , 90 , 100]}
              count={otherStates.total_count}
              page={otherStates.page}
              onPageChange={handlePageChange}
              rowsPerPage={otherStates.rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
   />
          </div>
        }
    </section>
    <Modal
  show={imageModal.show}
  onHide={() =>
    setImageModal({
      show: false,
      shipment: {},
      image: "",
    })
  }
>
  <Modal.Header closeButton>
    <Modal.Title>Image Proof</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {imageModal.image ? (
      <>
        <img
          src={imageModal.image}
          alt="proof"
          style={{
            width: "100%",
            borderRadius: "8px",
          }}
        />

        <hr />

        <label className="mb-2">
          Replace Image
        </label>

        <input
          type="file"
          accept="image/*"
          className="form-control"
          onChange={handleProofUpload}
        />
      </>
    ) : (
      <>
        <div className="alert alert-warning">
          No image available.
        </div>

        <label className="mb-2">
          Upload Image
        </label>

        <input
          type="file"
          accept="image/*"
          className="form-control"
          onChange={handleProofUpload}
        />
      </>
    )}

    {proofImage && (
      <div className="mt-3">
        <img
          src={URL.createObjectURL(proofImage)}
          alt="preview"
          style={{
            width: "100%",
            borderRadius: "8px",
          }}
        />
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <button
      className="btn btn-secondary"
      onClick={() =>
        setImageModal({
          show: false,
          shipment: {},
          image: "",
        })
      }
    >
      Close
    </button>

    <button
      className="btn btn-primary"
      onClick={uploadProofImage}
      disabled={imageUploading}
    >
      {imageUploading
        ? "Uploading..."
        : imageModal.image
        ? "Replace Image"
        : "Upload Image"}
    </button>
  </Modal.Footer>
</Modal>
      <Modal show={viewModal.show} onHide={() => setviewModal({ show: false, sub: {} })}>
        <Modal.Header closeButton>
          <Modal.Title>View and Update Dispute</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body">

            {/* Display Dispute Text */}
            <div className="mb-4">
              <label>Customer Dispute Text:</label>
              {viewModal.sub.discrepencies_dispute_issue && viewModal.sub.discrepencies_dispute_issue.length > 0 ?
                viewModal.sub.discrepencies_dispute_issue.map((item) => (
                  <textarea
                    className="form-control"
                    rows="3"
                    value={item}
                    disabled

                  />
                )) : ""}
            </div>

            {/* Display Uploaded Images */}
            {viewModal.sub.discrepencies_dispute_images && viewModal.sub.discrepencies_dispute_images.length > 0 && (
              <div className="mb-4">
                <label>Customer Attached Images and Videos:</label>
                <div className="d-flex flex-wrap">
                  {viewModal.sub.discrepencies_dispute_images.map((file, index) => (
                    <div key={index} className="m-2">
                      {file.endsWith('.jpg') || file.endsWith('.jpeg') || file.endsWith('.png') ? (
                        <a href={file} target="_blank" rel="noopener noreferrer">
                        <img
                          src={file}
                          alt={`attachment-${index}`}
                          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        />
                        </a>
                      ) : (
                        <video width="100" height="100" controls>
                          <source src={file} />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
   {/* Display Admin Dispute Text */}
            <div className="mb-4">
              {viewModal.sub.admin_discrepencies_dispute_issue ? <label>Admin Dispute Text:</label> : ""}
              {viewModal.sub.admin_discrepencies_dispute_issue && viewModal.sub.admin_discrepencies_dispute_issue.length > 0 ?
                viewModal.sub.admin_discrepencies_dispute_issue.map((item) => (
                  <textarea
                    className="form-control"
                    rows="3"
                    value={item}
                    disabled

                  />
                )) : ""}
            </div>

            {/* Display Uploaded Images */}
            {viewModal.sub.admin_discrepencies_dispute_images && viewModal.sub.admin_discrepencies_dispute_images.length > 0 && (
              <div className="mb-4">
                <label>Admin Attached Images and Videos:</label>
                <div className="d-flex flex-wrap">
                  {viewModal.sub.admin_discrepencies_dispute_images.map((file, index) => (
                    <div key={index} className="m-2">
                      {file.endsWith('.jpg') || file.endsWith('.jpeg') || file.endsWith('.png') ? (
                        <img
                          src={file}
                          alt={`attachment-${index}`}
                          style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                        />
                      ) : (
                        <video width="100" height="100" controls>
                          <source src={file} />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <textarea
              className="form-control mb-4"
              placeholder="Reply customer issue..."
              value={disputeText}
              onChange={(e) => setDisputeText(e.target.value)}
              rows="4"
            />
   <div className="mb-4">
              <label className="form-label">Upload Images (up to 3)</label>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleImageUpload}
                className="form-control"
              />
            </div>
    <div className="d-flex flex-wrap">
              {images.map((image, index) => (
                <div key={index} className="position-relative m-2">
                  <img
                    src={URL.createObjectURL(image)}
                    alt={`uploaded-${index}`}
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  />
  <button
                    type="button"
                    className="btn btn-danger btn-sm position-absolute top-0 end-0"
                    onClick={() => removeImage(index)}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
   <div className="mb-4">
              <label className="form-label">Upload Videos (up to 3)</label>
              <input
                type="file"
                accept="video/*"
                multiple
                onChange={handleVideoUpload}
                className="form-control"
              />
            </div>
  <div className="d-flex flex-wrap">
              {videos.map((video, index) => (
                <div key={index} className="position-relative m-2">
                  <video
                    src={URL.createObjectURL(video)}
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                    controls
                  />
                  <button
                    type="button"
                    className="btn btn-danger btn-sm position-absolute top-0 end-0"
                    onClick={() => removeVideo(index)}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
  </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setviewModal({ show: false, sub: {} })}>
            Close
          </button>
          <button className="btn btn-primary" onClick={() => handleupdateSubmit()}>
            Update Dispute
          </button>
        </Modal.Footer>
      </Modal>
      <div
  className={`offcanvas offcanvas-end ${showCanvas ? "show" : ""}`}
  style={{ visibility: showCanvas ? "visible" : "hidden", width: "1000px" }}>
  <div className="offcanvas-header">
    <h5>Shipment Detail</h5>
    <button className="btn-close" onClick={() => setShowCanvas(false)}></button>
  </div>
  <div className="offcanvas-body">
    {selectedShipmentId && (
      <Shipment_detail key={selectedShipmentId}  shipment_id={selectedShipmentId} />
    )}
  </div>
</div>
   </div>
  )
}
export default Weight_discrepencies_dispute
